import { render, staticRenderFns } from "./form_categories_marketplace_component.vue?vue&type=template&id=6d644c85&scoped=true"
import script from "./form_categories_marketplace_component.vue?vue&type=script&lang=js"
export * from "./form_categories_marketplace_component.vue?vue&type=script&lang=js"
import style0 from "./form_categories_marketplace_component.vue?vue&type=style&index=0&id=6d644c85&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d644c85",
  null
  
)

export default component.exports